// extracted by mini-css-extract-plugin
export default {"root":"muiCheckBox_root__fpkRP"};